"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectKeys = void 0;
/**
 * Helper to get the keys of an object in a typed way.
 * All it does is adding generic types around Object.keys().
 */
var getObjectKeys = Object.keys;
exports.getObjectKeys = getObjectKeys;
